import * as React from 'react';
import { CategoryData } from '../App';
import CategoryPage from './CategoryPage2';
import { ScrollToTop } from '../components/ScrollToTop';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { logConfig, WebsiteLogger } from '@prezi/client-logger-module';

export interface PreziData {
    can_reuse?: boolean;
    categories: Array<string>;
    description: string;
    element_id: string;
    landing_url: string;
    name: string;
    oid: string;
    owner_name: string;
    thumbnail_url: string;
    title: string;
}
export interface AppProps {
    categories: Array<CategoryData>;
    prezis: Array<PreziData>;
    categoryString: string;
}

interface RedirectMatchParams {
    url: string;
}

// TODO proper basepath
export const CATEGORY_ALL_SLUG = 'staff-picks';
const basePathRegex = '/([a-z][a-z])?/:cms?/:main/';

export class App extends React.Component<AppProps, any> {
    categories: Array<CategoryData>;
    categoryPath: string;
    defaultPath: string;
    categoryLookup: any;
    errors: Array<string>;
    categoryString: string;

    constructor(props: AppProps) {
        super(props);
        this.errors = [];
        this.categories = this.props.categories;
        this.categoryString = this.props.categoryString;

        const categoryRegex: string = this.generateSlugRegex(this.categories.map(category => category.slug));
        this.categoryPath = basePathRegex + categoryRegex;
        this.defaultPath = basePathRegex;

        this.categoryLookup = {};
        this.categories.forEach(category => {
            if (this.categoryLookup[category.slug]) {
                this.errors.push(`Duplicate category [${category.slug}] ${category.name}`);
            } else {
                this.categoryLookup[category.slug] = category;
            }
        });

        WebsiteLogger.initLogger(logConfig, '//log.prezi.com/log/json');
    }

    // TODO duplicate
    generateSlugRegex(slugs: Array<string>): string {
        return '(' + slugs.join('|') + ')';
    }

    // TODO duplicate
    buildBasePath(matchParams: {[group: string]: string}): string {
        const lang = matchParams['0'];
        const cms = matchParams['cms'];
        const main = matchParams['main'];

        let basePath = '/';

        if (lang) { basePath += lang + '/'; }
        if (cms) { basePath += cms + '/'; }
        basePath += main + '/';

        return basePath;
    }

    render () {
        return (
            <ScrollToTop>
                <Switch>
                    <Route exact={ true } strict={ true } path="/:url*"
                           render={ (props: RouteComponentProps<RedirectMatchParams>) => <Redirect to={ `${props.location.pathname}/` } /> }
                    />
                    <Route path={ this.categoryPath } render={ ({match}) => (
                        <CategoryPage
                            currentCategory={ this.categoryLookup[match.params[1]] }
                            categories={ this.categories }
                            prezis={ this.props.prezis }
                            basePath={ this.buildBasePath(match.params) }
                            categoryString={ this.categoryString }
                        />
                    ) } />
                    <Route path={ this.defaultPath } render={ ({match}) => (
                        <CategoryPage
                            currentCategory={ this.categoryLookup[CATEGORY_ALL_SLUG] }
                            categories={ this.categories }
                            prezis={ this.props.prezis }
                            basePath={ this.buildBasePath(match.params) }
                            categoryString={ this.categoryString }
                        />
                    ) } />
                </Switch>
            </ScrollToTop>
        );
    }
}



// WEBPACK FOOTER //
// ./assets/js/GalleryPage/App.tsx